// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mobile-navigation[data-v-74cf0618]{background:#004581;display:flex;justify-content:space-between}.mobile-navigation span[data-v-74cf0618]{padding:5px;font-size:1em;color:#6ba8d8;text-transform:uppercase}.back-btn[data-v-74cf0618]{border:none;background:#004581;color:#fff}.back-btn .icon[data-v-74cf0618]{font-size:1em}", ""]);
// Exports
module.exports = exports;
